module.exports = __webpack_public_path__ + "img/yuancheng.1a5286ed.png";